import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTithesReport = ({ churchId, budgetYearId, page, pageSize }) => {
  return axios.get(
    `/churches/${churchId}/tithes-report?budget_year_id=${budgetYearId}&page=${page}&page_size=${pageSize}`
  );
};

export const useTithesReport = ({
  churchId,
  budgetYearId,
  page = 1,
  pageSize = 10,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["tithes-report", churchId, budgetYearId, page, pageSize],
    queryFn: () => getTithesReport({ churchId, budgetYearId, page, pageSize }),
    enabled: !!churchId && !!budgetYearId,
    select: data => data.result
  });
};
